// extracted by mini-css-extract-plugin
module.exports = {"module":"EmailModulePreview_module__2_RoI","name":"EmailModulePreview_name__3R3xe","preview":"EmailModulePreview_preview__3n_6W"};